const START_FETCH = 'auth/START_FETCH';
const END_FETCH = 'auth/END_FETCH';
const END_ERROR = 'auth/END_ERROR';
const UPDATE_PROFILE = 'auth/UPDATE_PROFILE';
const UPDATE_USER = 'auth/UPDATE_USER';
const API_CALL = 'auth/API_CALL';
const CHANGE_LANGUAGE = 'auth/CHANGE_LANGUAGE';
const CHANGE_PASSWORD = 'auth/CHANGE_PASSWORD';
const MESSAGE = 'auth/MESSAGE';
const CLEAR = 'auth/CLEAR';
const LOGIN = 'auth/LOGIN';
const SIGN_IN = 'auth/SIGN_IN';
const LOGOUT = 'auth/LOGOUT';
const UPDATE_TOKEN_EXP = 'auth/UPDATE_TOKEN_EXP';
const DOWNLOAD_QR = 'auth/DOWNLOAD_QR';

export default {
  START_FETCH,
  END_FETCH,
  END_ERROR,
  UPDATE_PROFILE,
  UPDATE_USER,
  API_CALL,
  CHANGE_LANGUAGE,
  CHANGE_PASSWORD,
  MESSAGE,
  CLEAR,
  LOGIN,
  SIGN_IN,
  LOGOUT,
  UPDATE_TOKEN_EXP,
  DOWNLOAD_QR,
};
